import React from "react";
import { Checkbox } from "../../Checkbox";
import { Input } from "../../Input";
import { RadioButtons } from "../../RadioButtons";
import { Select } from "../../Select";
import { StaticInputValue, StaticMultipleValues } from "../../StaticInput";
import { Tooltip } from "../../Tooltip";
import { FormGridColumnTypes, } from "../../types/FormGrids";
import { CheckedState, SetRadioButton } from "./FormGridComponents";
import { v4 as uuidv4 } from "uuid";
export const FormGridInput = (props) => {
    const { helperTooltip } = props;
    if (helperTooltip && props?.column.type === FormGridColumnTypes.Checkbox) {
        return (React.createElement(Tooltip, { tooltipId: uuidv4(), content: helperTooltip, iconShown: false },
            React.createElement(FormGridInputComponents, { ...props })));
    }
    return React.createElement(FormGridInputComponents, { ...props });
};
export const FormGridInputComponents = ({ column, labelHidden, viewState, rowId, disabled, dataId, dataTestId, }) => {
    const { id: name, required } = column;
    const isValid = (v) => (required ? !!v : true);
    switch (column.type) {
        case FormGridColumnTypes.Text:
            if (column.read || viewState === "read") {
                return (React.createElement(StaticInputValue, { name: name, label: column.label, labelHidden: true, staticFormatter: column.staticFormatter, dataId: dataId && `${dataId}-staticInput`, dataTestId: dataTestId && `${dataTestId}-staticInput` }));
            }
            else {
                return (React.createElement(Input, { label: column.label, type: "text", name: name, valid: isValid, onChange: (value) => column.onChange && column.onChange(rowId, value), uniqueId: `${name}-${rowId}`, labelHidden: labelHidden, disabled: disabled, dataId: dataId && `${dataId}-input`, dataTestId: dataTestId && `${dataTestId}-input` }));
            }
        case FormGridColumnTypes.Radio:
            if (column.read || viewState === "read") {
                return column.staticFormatter ? (React.createElement(StaticMultipleValues, { name: name, label: column.label, labelHidden: true, staticFormatter: column.staticFormatter, options: column.options, dataId: dataId && `${dataId}-multiValue`, dataTestId: dataTestId && `${dataTestId}-multiValue` })) : (React.createElement(SetRadioButton, { name: name, options: column.options, dataId: dataId && `${dataId}-setRadioButton`, dataTestId: dataTestId && `${dataTestId}-setRadioButton` }));
            }
            else {
                return (React.createElement(RadioButtons, { name: name, label: !labelHidden ? column.label : undefined, options: column.options ?? [], type: "button", onChange: (option) => column.onChange && column.onChange(rowId, option), valid: isValid, uniqueId: `${name}-${rowId}`, disabled: disabled, dataId: dataId && `${dataId}-radioButton`, dataTestId: dataTestId && `${dataTestId}-radioButton` }));
            }
        case FormGridColumnTypes.Select:
            if (column.read || viewState === "read") {
                return (React.createElement(StaticMultipleValues, { name: name, label: column.label, labelHidden: true, staticFormatter: column.staticFormatter, options: column.options ?? [], dataId: dataId && `${dataId}-multiValue`, dataTestId: dataTestId && `${dataTestId}-multiValue` }));
            }
            else {
                return (React.createElement(Select, { label: column.label, name: name, options: column.options ?? [], labelHidden: labelHidden, onChange: (option) => column.onChange && column.onChange(rowId, option), valid: isValid, uniqueId: `${name}-${rowId}`, disabled: disabled, dataId: dataId && `${dataId}-select`, dataTestId: dataTestId && `${dataTestId}-select` }));
            }
        case FormGridColumnTypes.Checkbox:
            if (column.read || viewState === "read") {
                return React.createElement(CheckedState, { name: name });
            }
            else {
                return (React.createElement(Checkbox, { name: name, description: column.label, descriptionHidden: labelHidden, onChange: (value) => column.onChange && column.onChange(rowId, value), valid: isValid, uniqueId: `${name}-${rowId}`, disabled: disabled, dataId: dataId && `${dataId}-checkbox`, dataTestId: dataTestId && `${dataTestId}-checkbox` }));
            }
        default:
            return null;
    }
};
